// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__kJdzA","footer":"ModalCreateQualiphyProcedure_footer__Qurcp","additionData":"ModalCreateQualiphyProcedure_additionData__2iuz3"};